import { render, staticRenderFns } from "./PdvOrder.vue?vue&type=template&id=44f37f3b"
import script from "./PdvOrder.vue?vue&type=script&lang=js"
export * from "./PdvOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports